
<template>
  <div>
    <index-card :loading="loading">
      <template slot="header">
        <div>
          <v-btn text icon large @click="$router.push({name: 'Home'})" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push({name:'CreateSuppliers'})" center>
            <v-icon small left>mdi-plus</v-icon>Adicionar Fornecedores
          </v-btn>
        </div>
        <div class="d-flex align-center headline white--text">
          <span>
            Lista de fornecedores
          </span>
          <v-icon class="white--text ml-2">mdi-factory</v-icon>
        </div>
      </template>
      <template slot="subheader">
        <div class="brands-list-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">

        <v-card v-if="!loading">
          <v-card-text>
            <v-treeview 
              v-if="!loading" 
              :active.sync="active"
              :items="brands" 
              :open.sync="open" 
              :load-children="fetchChildren"
              :search="search"
              item-key="uniqueId" 
              class="text-start" 
              transition
              activatable 
              active-class="red--text" 
              return-object 
              hoverable
              
            >
              <template slot="prepend" slot-scope="{ item, open }">                
                <v-icon v-if="!item.file && item.id" color="red darken-3">
                  {{
                    item.type == 'brand' ? 'mdi-factory' :
                    item.type == 'pickup_location' ? 'mdi-store ' :
                    item.type == 'product_pickup_location' ? 'mdi-package-variant-closed' :
                    item.type == 'product_price' ? 'mdi-currency-usd' : ''
                  }}
                </v-icon>
                
                <!-- {{                     
                  item.type == 'brand' ? '[brand]' :
                  item.type == 'pickup_location' ? '[pickup_location]' :
                  item.type == 'product_pickup_location' ? '[product_pickup_location]' :
                  item.type == 'product_price' ? '[product_price]' : ''
                }} #{{ item.id }}  -->

                
                <!-- {{ item.name }} -->

                <!-- [{{ item.name }} - id: {{item.id}}] -->
                <!-- {{ item.type != 'product_pickup_location' && item.type != 'product_price' ? [item.type] : ''}} -->
                <!-- {{item.type == 'product_pickup_location' && item.type != 'product_price' ? 'pplid: [' + item.product_pickup_locations_id + ']' : ''}} -->
                <!-- => -->
                <!-- {{ item.brand_index != undefined ? '{idx_B ' + item.brand_index + '}' : '' }}  -->
                <!-- {{ item.pickup_location_index != undefined ? '{idx_PL ' + item.pickup_location_index + '}' : '' }} -->
                <!-- {{ item.product_pickup_location_index != undefined ? '{idx_PPL ' + item.product_pickup_location_index + '}' : '' }} -->
                <!-- {{ item.product_price_index != undefined ? '{idx_PP ' + item.product_price_index + '}' : '' }} -->

                
                <!-- {{ item }} -->

              </template>
              <template slot="append" slot-scope="{ item }">
                <v-btn icon text class="white--text" @click="editItem(item)" v-if="item.type != 'product_price' && item.name != '' && item.name != 'Não possui preços cadastrados.'" color="primary">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>

        <router-view></router-view>

      </template>
    </index-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Api from '@/api/index'

export default {
  name: 'BrandsList',
  data() {
    return {
      brands: [],
      open: [],
      tree: [],
      active: [],
      search: '',
      sup: null,
      loading: true,
      loading_pickup_location: true,
      all_brands: []
    }
  },
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  methods: {
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
    },
    generateUniqueId(type, originalId, index = null) {
      // Gera um ID único baseado no tipo, ID original e índice
      const timestamp = Date.now()
      const random = Math.random().toString(36).substr(2, 9)
      return `${type}_${originalId}_${index !== null ? index : ''}_${timestamp}_${random}`
    },
    mapParams(item){
      let data = {
        params: null,
      }
      
      if(item.type == 'brand'){
        console.log(1)
        data.MODULE = 'PickupLocation'
        data.params = {brand_id: item.id}
        data.brand_index = item.brand_index
      }
      
      if(item.type == 'pickup_location'){
        console.log(2)
        data.MODULE = 'Product'
        data.params = {pickup_location_id: item.id, short_serializer: true}
        
        data.brand_idx = item.brand_index
        data.pickup_location_index = item.pickup_location_index
      }
      
      
      if(item.type == 'product_pickup_location'){
        console.log(3)
        data.MODULE = 'ProductPrice'
        data.params = {product_pickup_location_id: item.product_pickup_locations_id}

        data.brand_idx = item.brand_index
        data.pickup_location_index = item.pickup_location_index
        data.product_pickup_location_index = item.product_pickup_location_index
      }

      console.log('mapParams', item, data)

      
      return data
    },  
    async fetchChildren(item){
      let data = this.mapParams(item)      
      
      await Api[data.MODULE].index(data.params).then(r=>{

        if( data.MODULE == 'PickupLocation' ){
          if(this.brands[data.brand_index].children.length == 0){
            console.log('populando pickup_locations')
            const newChildren = r.data.map((el, index) => ({
              ...el, 
              children: [], 
              type: 'pickup_location', 
              brand_index: data.brand_index, 
              pickup_location_index: index,
              uniqueId: this.generateUniqueId('pickup_location', el.id, index)
            }))
            // Usa nextTick para garantir que a atualização aconteça após o ciclo de renderização
            this.$nextTick(() => {
              this.$set(this.brands[data.brand_index], 'children', newChildren)
            })
          }
        }

        if(data.MODULE == 'Product'){
          console.log('populando product_pickup_locations')

          if(this.brands[data.brand_idx].children[data.pickup_location_index].children.length == 0){

            if(r.data.length > 0){
              const newChildren = r.data.map((el, index) => ({
                ...el, 
                type: 'product_pickup_location', 
                children: [], 
                brand_index: item.brand_index, 
                pickup_location_index: item.pickup_location_index, 
                product_pickup_location_index: index,
                uniqueId: this.generateUniqueId('product_pickup_location', el.id, index)
              }))
              this.$nextTick(() => {
                this.$set(this.brands[data.brand_idx].children[data.pickup_location_index], 'children', newChildren)
              })
            }else{
              console.log('pushing product_pickup_locations nao cadastrados')
              const emptyChild = {
                name: 'Não possui preços cadastrados.',
                type: 'product_pickup_location', 
                brand_index: item.brand_index, 
                pickup_location_index: item.pickup_location_index, 
                product_pickup_location_index: 0,
                uniqueId: this.generateUniqueId('product_pickup_location_empty', 'empty', 0)
              }
              this.$nextTick(() => {
                this.$set(this.brands[data.brand_idx].children[data.pickup_location_index], 'children', [emptyChild])
              })
            }

          }
        }

        if(data.MODULE == 'ProductPrice'){
          console.log('populando product_prices')
          console.log('children product', this.brands[data.brand_idx].children[data.pickup_location_index].children[data.product_pickup_location_index])

          if(this.brands[data.brand_idx].children[data.pickup_location_index].children[data.product_pickup_location_index].children == 0){
            if(r.data.length > 0){
              const newChildren = r.data.map((el, index) => ({
                ...el, 
                name: `${el.company_name} - ${ Number(el.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }`, 
                type: 'product_price', 
                brand_index: item.brand_index, 
                pickup_location_index: item.pickup_location_index, 
                product_pickup_location_index: index, 
                product_price_index: index,
                uniqueId: this.generateUniqueId('product_price', el.id, index)
              }))
              this.$nextTick(() => {
                this.$set(this.brands[data.brand_idx].children[data.pickup_location_index].children[data.product_pickup_location_index], 'children', newChildren)
              })
              
            }else{
              console.log('pushing product_price nao cadastrados')
              const emptyChild = {
                name: 'Não possui preços cadastrados.',
                type: 'product_price',
                brand_index: item.brand_index,
                pickup_location_index: item.pickup_location_index,
                product_pickup_location_index: item.product_pickup_location_index,
                product_price_index: 0,
                uniqueId: this.generateUniqueId('product_price_empty', 'empty', 0)
              }
              this.$nextTick(() => {
                this.$set(this.brands[data.brand_idx].children[data.pickup_location_index].children[data.product_pickup_location_index], 'children', [emptyChild])
              })
            }
          }
        }

      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading_pickup_location = false
      })
    },
    getSuppliers(){
      Api.Brand.index().then(r=>{
        this.brands = r.data.map((el , idx) => {
          return {
            ...el, 
            children: [], 
            type: 'brand', 
            brand_index: idx,
            uniqueId: this.generateUniqueId('brand', el.id, idx)
          }
        })
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    editItem(item) {
      var sup_kind = {}
      console.log(item)
      if(item.type == 'brand') sup_kind = {id: item.id, name: 'EditBrand', type: 'brands'}
      if(item.type == 'pickup_location') sup_kind = {id: item.id, name: 'EditPickupLocation', type: 'pickup_locations'}
      if(item.type == 'product_pickup_location') sup_kind = {id: item.product_pickup_locations_id, name: 'EditProductPickupLocation', type: 'product_pickup_locations'} 
      // if(item.type == 'product_price') sup_kind = 'product_prices'

      this.$router.push({name: sup_kind.name, params: {id: sup_kind.id, type: sup_kind.type}})
    },
    ...mapActions({
      getBanks: 'Bank/index'
    })
  },
  watch: {
    '$route.params.get_list'(nv, ov) {
      if(nv){
        this.loading = true
        this.getSuppliers()
      }
    },
    // all_brands(nv, ov) {
    //   var sup_aux = []
    //   if (nv) {
    //     nv.forEach((brand, b_index) => {
    //       var b = {}
    //       var { id, name, pLocations } = brand.attributes
    //       b = {
    //         id: id,
    //         name: name,
    //         children: [],
    //         kind: 'brand'
    //       }
    //       var pls = {}
    //       var ppls = {}
    //       var pps = {}
    //       var bcc = {}
    //       if (pLocations) {
    //         pLocations.data.forEach((pl, pl_index) => {
    //           var { id, name, ppl } = pl.attributes
    //           pls = {
    //             id: id,
    //             name: name,
    //             children: [],
    //             kind: 'pls'
    //           }
    //           ppl.data.forEach((ppl, ppl_index) => {
    //             var { id, product_name, prices } = ppl.attributes
    //             ppls = {
    //               id: id,
    //               name: product_name,
    //               children: [],
    //               kind: 'Ppl',
    //             }
    //             prices.data.forEach((price, price_index) => {
    //               var { id, price, company_price, active } = price.attributes
    //               if (active) {
    //                 pps = {
    //                   id: id,
    //                   name: `${company_price} - R$ ${price}`,
    //                   kind: 'price'
    //                 }
    //                 ppls.children.push(pps)
    //               }
    //               pps = {}
    //             });
    //             ppl.attributes.status_id == 1 ? pls.children.push(ppls) : console.log('ppl inactive');
    //             ppls = {}
    //           });
    //           pl.attributes.status_id == 1 ? b.children.push(pls) : console.log('pl inactive')
    //           pls = {}
    //         });
    //       }
    //       sup_aux.push(b)
    //     });
    //     this.sup = sup_aux
    //   }
    //   this.loading = false
    // },
  },
  created() {
    this.getBanks()
    this.getSuppliers()
  },
  beforeDestroy() {
    // this.clearAllSuppliers('brands')
  },
}
</script>

<style scoped>
.brands-list-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.brands-list-filters >>> .filter-data-card {
  width: 100%;
}
</style>